import React from 'react'
import AboutSection from '../../Components/TopHeader/topheader'
import HoroscopeSection from '../HomePages/HomeHoroscope/homehoroscope'
import TestimonialSlider from '../HomePages/hometestimonials/hometestimonials'
import HeroSpeciality from '../HomePages/homespeciality/Homespeciality'
import MembershipHero from '../HomePages/joinushomepage/joinushomepage'

export default function Horoscope() {
  return (
    <div className='Horoscope-page-main-container'>
        <AboutSection
  title="HOROSCOPE"
  description="Your personalized astrology hub — check your horoscope, explore zodiac traits, and receive daily cosmic updates to help you make confident decisions."
/>
<HoroscopeSection />
<TestimonialSlider/>
<HeroSpeciality/>
<MembershipHero />


    </div>
  )
}
